import { ADD_SQUARE, REMOVE_SQUARE, REPLACE_SQUARE, ALTER_SQUARE, SELECT_SQUARE, TOGGLE_DEATH, ADD_STAR, POP_STAR, COMBINE_STARS, SCORE_STARS, SET_SQUARES } from './types';
import { getSelectedSquares } from '../selectors';
import { addSet, addMistake, addPoints, setFailed } from './level';
import { addTool } from './tools';
import { PROPERTIES, randomAnimal, randomColor, randomDirection, checkSquaresForSet, failure_codes } from '../utilities';

import getLevelDef from '../level_definitions';

export function setSquares(squares) {
  return {
    type : SET_SQUARES,
    payload : squares
  }
}

export function addSquare(parent_id, leveldef) {
  return {
    type    : ADD_SQUARE,
    payload : { parent_id, leveldef }
  }
}

export function removeSquare(parent_id) {
  return {
    type    : REMOVE_SQUARE,
    payload : parent_id
  }
}

export function toggleDeath( {id, deadCount} ) {
  return {
    type: TOGGLE_DEATH,
    payload: {id, deadCount},
  }
}

export function replaceSquare( square ) {
  return {
    type : REPLACE_SQUARE,
    payload : square,
  }
}

export function addStar( {id, depth} ) {
  return (dispatch, getState) => {
      dispatch({ type : ADD_STAR, payload : {id, depth} });
      dispatch(scoreStars(depth));
      const { level, squares } = getState();
      let square = {
        ...squares[id],
        animal    : randomAnimal(level.animals),
        fill      : randomColor(level.palette),
        direction : randomDirection(level.directions)
      }
      dispatch(replaceSquare(square));
  }
}

export function popStar( {id} ) {
  return (dispatch, getState) => {
    dispatch({ type : POP_STAR, payload: { id } });

    const {tool, level, squares} = getState();
    let square = {
      ...squares[id],
      animal    : randomAnimal(level.animals),
      fill      : randomColor(level.palette),
      direction : randomDirection(level.directions)
    }
    dispatch(replaceSquare(square));

    const depth = squares[id].depth;

    if (depth === 2) {
      const tools = Object.keys(tool.available);
      const randomTool = tools[Math.floor(Math.random() * tools.length)];
      dispatch(addTool({[randomTool] : 1}));
    }
    else if (depth === 1) {
      const tools = Object.keys(tool.available);
      let numTools = 12;
      let newTools = {};
      while (numTools > 0) {
        const randomTool = tools[Math.floor(Math.random() * tools.length)];
        if (newTools[randomTool] === undefined) {
          newTools[randomTool] = 0;
        }
        newTools[randomTool]++;
        numTools--;
      }
      dispatch(addTool(newTools));
    }
  }
}

export function scoreStars(depth) {
  return {
    type : SCORE_STARS,
    payload : depth,
  }
}

export function combineStars(square_id) {
  return {
    type : COMBINE_STARS,
    payload : square_id
  }
}

export function alterSquare ( target_id, source_id, tool ) {
  return (dispatch, getState) => {
    dispatch({
      type : ALTER_SQUARE,
      payload : { target_id, source_id, tool }
    });

    if (!checkSquaresForSet(getState().squares) && tool.value === undefined) {
      dispatch(setFailed(failure_codes.LOCKED_BOARD));
    }
  }
}

function setSquareSelection(square_id) {
  return {
    type    : SELECT_SQUARE,
    payload : square_id
  };
}

export function selectSquare(square_id) {

  return (dispatch, getState) => {
      let parent_id = getState().squares[square_id].parent_id;

      let selection = getSelectedSquares(getState());
      if (selection.length === 3) {
        selection.forEach( sq => {
          if (sq.id === square_id) {
            dispatch(setSquareSelection(square_id));
          }
        });
        return null;
      };

      dispatch(setSquareSelection(square_id));
      selection = getSelectedSquares(getState());

      if (selection.length === 3) {
        let [square1, square2, square3] = selection;
        let mismatches = {};
        let points = {};

        const isSet = PROPERTIES.reduce( (acc, prop) => {

          let inc = 0;

          if (square1[prop] === square2[prop] && square2[prop] === square3[prop]) {
            inc = 2;
          }
          else if (square1[prop] !== square2[prop] && square1[prop] !== square3[prop] && square2[prop] !== square3[prop]) {
            inc = 1;
          }
          else {
            mismatches[prop] = true;
          }

          points[prop] = inc;

          return acc * inc;

        }, 1);

        if (isSet) {
          dispatch(addSet( { squares : [ square1, square2, square3 ], mismatches, points } ));
          const streak_multiplier = Math.ceil(getState().level.streak / 10);
          dispatch(addPoints(streak_multiplier * isSet));
        }
        else {
          dispatch(addMistake( { squares : [ square1, square2, square3 ], mismatches, points : PROPERTIES.reduce( (acc, prop) => { acc[prop] = 0; return acc }, {}) } ));
        }

        const leveldef = getLevelDef(getState().level.level);

        selection.forEach(sq => {
          dispatch(setSquareSelection(sq.id));
          if (isSet && (sq.depth < 3 || leveldef.children[sq.id]) ) {
            dispatch(addSquare(sq.id, leveldef))
          }
          else {
            const DEATH_MAP = { 1 : 6, 2 : 4, 3 : 2};
            const func = isSet ? addStar : toggleDeath;
            dispatch(func({id : sq.id, deadCount : DEATH_MAP[sq.depth], depth : sq.depth}))
          }
        });

        const numStars = countStars(getState().squares);

        dispatch(combineStars(square_id));
        let combinedStars = countStars(getState().squares);
        if (combinedStars !== numStars) {
          dispatch(scoreStars(2));
          dispatch(addPoints(100));
        }
        if (parent_id) {
          dispatch(combineStars(parent_id));
          let combinedParentStars = countStars(getState().squares);
          if (combinedParentStars !== combinedStars) {
            dispatch(scoreStars(1));
            dispatch(addPoints(1000));
          }
        }

        if (!checkSquaresForSet(getState().squares) && !getState().level.success) {
          dispatch(setFailed(failure_codes.LOCKED_BOARD));
        }

      }

  }
}

function countStars(squares) {
  return Object.values(squares).reduce ( (count, square) => {
    if (square.star) {
      count++;
    }
    return count;
  }, 0);
}



// WEBPACK FOOTER //
// ./src/actions/squares.js